import { defineStyleConfig } from "@chakra-ui/react";

const appLinkColorStyle = {
  color: "magenta.veryDark",
  _hover: {
    color: "magenta.dark",
  },
};

const appLinkStateStyle = {
  _hover: {
    textDecoration: "none",
  },
  _disabled: {
    cursor: "default",
    opacity: 0.6,
    pointerEvents: "none",
  },
  "tr[aria-selected=true] &": {
    color: "gray.300",
    _hover: {
      color: "gray.100",
    },
  },
};

export const appLinkStyle = {
  ...appLinkColorStyle,
  ...appLinkStateStyle,
};

export default defineStyleConfig({
  baseStyle: {
    ...appLinkStateStyle,
    "&:not(.chakra-button)": appLinkColorStyle,
  },
});
